export const focusRequestLead = function () {
  $('#srp-lead-modal, #ldpBottomLeadModal, #request-private-showing, #ldpStickyBottomLeadModal').on('shown.bs.modal', function() {
    let requestLeadName   = $(this).find('.fullName'),
        requestLeadEmail  = $(this).find('.email'),
        requestLeadPhone =  $(this).find('.phone');
    
    let  modalContent     = $(this).find('.modal-content');
    
    requestLeadName.on('focus', function() {
      // get textarea's offset top position
      if (!MOVE_DATA.ab_lf_redesign_2) {         
        modalContent.animate({
          scrollTop: MOVE_DATA.ab_lf_redesgin ? 42: 52
        });
      }
    });
    requestLeadEmail.on('focus', function() {
      // get textarea's offset top position
      modalContent.animate({
        scrollTop: MOVE_DATA.ab_lf_redesgin? 90 : 100
      });
    });
    requestLeadPhone.on('focus', function() {
      // get textarea's offset top position
      modalContent.animate({
        scrollTop: MOVE_DATA.ab_lf_redesgin ? 138 : 148
      });
    });
    
    if (!requestLeadName.val()) {
      requestLeadName.trigger("focus");
    } else if(!requestLeadEmail.val()) {
      requestLeadEmail.trigger("focus");
    }
    // for LDP94, we set focus even field isn't empty
    if (MOVE_DATA.ab_lf_redesign_2) {
      requestLeadName.trigger("focus");
    }
  });
}



// WEBPACK FOOTER //
// ./shared_non_critical/lead-open-keyboard.js